module.exports = __webpack_public_path__ + "static/media/up_white.65f6500b.svg";